export enum ExternalURL {
  ARTIFACT_HUB = 'https://artifacthub.io/packages/helm/deeploy-core/deeploy',
}
